var map = {
	"./01.webp": 3640,
	"./02.webp": 4888,
	"./03.webp": 2940,
	"./04.webp": 1268,
	"./05.webp": 9600,
	"./06.webp": 5464,
	"./7.webp": 9304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5040;